import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=57d4aa5c&scoped=true&"
import script from "./BlankLayout.vue?vue&type=script&lang=js&"
export * from "./BlankLayout.vue?vue&type=script&lang=js&"
import style0 from "./BlankLayout.vue?vue&type=style&index=0&id=57d4aa5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d4aa5c",
  null
  
)

component.options.__file = "BlankLayout.vue"
export default component.exports